import React, { useCallback, useEffect } from 'react';
import { SharedIndex } from '../shared';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../store/hooks';
import { getMifflinBMR } from '../../../shared/utils/utilFunctions';
import { metaDataSelector } from '../../../store/globalSelectors';
import {
  setMifflinBMR,
  setMifflinSummary,
  setMifflinSelection,
  setMifflinActivityFactor,
  setMifflinActivityFactorPAL_Input,
  setMifflinActivityFactorPAL_Select
} from '../../../store/slices/metaDataSlice';

const MifflinStJeor = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { patientInformation, estimatingRequirements } =
    useAppSelector(metaDataSelector);
  const { metric } = patientInformation;
  const {
    selection,
    activityFactor,
    activityFactorPAL_Input,
    activityFactorPAL_Select
  } = estimatingRequirements.mifflinStJeor;

  useEffect(() => {
    dispatch(
      setMifflinBMR(
        getMifflinBMR(
          patientInformation?.age?.years,
          patientInformation?.gender.toLowerCase(),
          metric?.estimatedDryWeight || metric?.weight,
          metric?.height
        )
      )
    );
  }, []);

  const getNextRoute = useCallback(() => {
    if (
      location.pathname === '/estimating-requirements/mifflinStJeor' &&
      selection?.activityFactor
    ) {
      return '/estimating-requirements/mifflinStJeor/activityOrPAL';
    }
    return patientInformation.type === 'PAEDIATRIC'
      ? '/estimating-requirements/paediatric-energy'
      : '/estimating-requirements/protein';
  }, [selection.activityFactor, location.pathname]);

  return (
    <SharedIndex
      title={'MIFFLIN-ST. JEOR'}
      selection={selection}
      nextPageRoute={getNextRoute()}
      activityFactor={activityFactor}
      setSummaryVal={setMifflinSummary}
      handleSelectionToggle={setMifflinSelection}
      setActivityFactor={setMifflinActivityFactor}
      activityFactorPAL_Input={activityFactorPAL_Input}
      activityFactorPAL_Select={activityFactorPAL_Select}
      BMRVal={estimatingRequirements.mifflinStJeor.bmr}
      summary={estimatingRequirements.mifflinStJeor.summary}
      setActivityFactorPAL_Input={setMifflinActivityFactorPAL_Input}
      setActivityFactorPAL_Select={setMifflinActivityFactorPAL_Select}
    />
  );
};

export { MifflinStJeor };
